export const MONITORING_QUEUE_ENTRY_TYPES = {
  WATCHLIST_MANUAL_SEARCH: 1,
  WATCHLIST_REGULAR_SEARCH: 2,
  API_SCORING: 3,
  BATCH_SCORING: 4,
  REGULAR_SCORING: 5,
  NEGATIVE_MEDIA_INFO: 7,
  NEGATIVE_MEDIA_ELASTIC_BASED: 8,
};

export const typeOptions = [
  {
    value: MONITORING_QUEUE_ENTRY_TYPES.WATCHLIST_MANUAL_SEARCH,
    label: "Watchlist manual search",
  },
  {
    value: MONITORING_QUEUE_ENTRY_TYPES.WATCHLIST_REGULAR_SEARCH,
    label: "Watchlist regular search",
  },
  {
    value: MONITORING_QUEUE_ENTRY_TYPES.API_SCORING,
    label: "API scoring",
  },
  {
    value: MONITORING_QUEUE_ENTRY_TYPES.BATCH_SCORING,
    label: "Batch scoring",
  },
  {
    value: MONITORING_QUEUE_ENTRY_TYPES.REGULAR_SCORING,
    label: "Regular scoring",
  },
  {
    value: MONITORING_QUEUE_ENTRY_TYPES.NEGATIVE_MEDIA_INFO,
    label: "Negative media",
  },
  {
    value: MONITORING_QUEUE_ENTRY_TYPES.NEGATIVE_MEDIA_ELASTIC_BASED,
    label: "Semantic Negative Media",
  },
];

export const displayTypeLabel = ({ type, categoryType }) => {
  const labelsForCategoryTypes = {
    1: "Watchlist regular search",
    2: "Watchlist PEP regular search",
    3: "Watchlist Negative Info List regular search",
  };
  if (Number(type) === 2) {
    return labelsForCategoryTypes[Number(categoryType)];
  }

  return typeOptions.find((to) => to.value === Number(type)).label;
};

export const clientIsActiveOptions = [
  {
    value: true,
    label: "Yes",
  },
  {
    value: false,
    label: "No",
  },
];

export const MONITORING_QUEUE_RISK_LEVEL_TYPES = {
  NORMAL_RISK: "Normal",
  MEDIUM_RISK: "Medium",
  HIGH_RISK: "High",
};

export const riskLevelOptions = [
  {
    value: MONITORING_QUEUE_RISK_LEVEL_TYPES.NORMAL_RISK,
    label: "Normal risk",
  },
  {
    value: MONITORING_QUEUE_RISK_LEVEL_TYPES.MEDIUM_RISK,
    label: "Medium risk",
  },
  {
    value: MONITORING_QUEUE_RISK_LEVEL_TYPES.HIGH_RISK,
    label: "High risk",
  },
];

export const watchListDecisionOptions = [
  {
    value: 0,
    label: "Pending",
  },
  {
    value: 1,
    label: "False Positive",
  },
  {
    value: 2,
    label: "True Match",
  },
];

export const RegularSearchingCategoryType = [
  {
    value: 0,
    label: "All",
  },
  {
    value: 1,
    label: "Combined",
  },
  {
    value: 2,
    label: "PEP",
  },
  {
    value: 3,
    label: "Negative Info List",
  },
];

export const RegularSearchingCategoryTypeLabels = {
  0: "All",
  1: "Combined",
  2: "PEP",
  3: "Negative Info List",
};

export const watchListDecisionOptionsLabels = {
  PENDING: "Pending",
  FALSE_POSITIVE: "False Positive",
  TRUE_MATCH: "True Match",
};

export const MONITORING_QUEUE_STATUS_TYPES = {
  PENDING: 1,
  REJECTED_HIGH_RISK: 2,
  ESCALATED: 3,
  APPROVED_HIGH_RISK: 4,
  APPROVED_MEDIUM_RISK: 5,
  APPROVED_NORMAL_RISK: 6,
};

export const statusOptions = [
  {
    value: MONITORING_QUEUE_STATUS_TYPES.PENDING,
    label: "Pending",
  },
  {
    value: MONITORING_QUEUE_STATUS_TYPES.REJECTED_HIGH_RISK,
    label: "Rejected High Risk",
  },
  {
    value: MONITORING_QUEUE_STATUS_TYPES.ESCALATED,
    label: "Escalated",
  },
  {
    value: MONITORING_QUEUE_STATUS_TYPES.APPROVED_HIGH_RISK,
    label: "Approved High Risk",
  },
  {
    value: MONITORING_QUEUE_STATUS_TYPES.APPROVED_MEDIUM_RISK,
    label: "Approved Medium Risk",
  },
  {
    value: MONITORING_QUEUE_STATUS_TYPES.APPROVED_NORMAL_RISK,
    label: "Approved Normal Risk",
  },
];

export const MONITORING_QUEUE_WATCHLIST_MATCH_TYPES = {
  YES: true,
  NO: false,
};

export const MONITORING_QUEUE_MEDIA_MATCH_TYPES = {
  YES: true,
  NO: false,
};

export const MONITORING_QUEUE_MEDIA_DECISION = {
  PENDING: 0,
  FALSE_POSITIVE: 1,
  TRUE_MATCH: 2,
};

export const mediaMatchOptions = [
  {
    value: MONITORING_QUEUE_MEDIA_MATCH_TYPES.YES,
    label: "Yes",
  },
  {
    value: MONITORING_QUEUE_MEDIA_MATCH_TYPES.NO,
    label: "No",
  },
];

export const mediaDecisionOptions = [
  {
    value: MONITORING_QUEUE_MEDIA_DECISION.PENDING,
    label: "Pending",
  },
  {
    value: MONITORING_QUEUE_MEDIA_DECISION.FALSE_POSITIVE,
    label: "False positive",
  },
  {
    value: MONITORING_QUEUE_MEDIA_DECISION.TRUE_MATCH,
    label: "True match",
  },
];

export const MONITORING_QUEUE_WATCHLIST_MATCH_STATUS_TYPES = {
  INITIAL: 0,
  FALSE_POSITIVE: 1,
  TRUE_MATCH: 2,
};

export const watchListMatchStatusOptions = [
  {
    value: MONITORING_QUEUE_WATCHLIST_MATCH_STATUS_TYPES.INITIAL,
    label: "In Review",
    key: 0,
  },
  {
    value: MONITORING_QUEUE_WATCHLIST_MATCH_STATUS_TYPES.FALSE_POSITIVE,
    label: "False Positive",
    key: 1,
  },
  {
    value: MONITORING_QUEUE_WATCHLIST_MATCH_STATUS_TYPES.TRUE_MATCH,
    label: "True Match",
    key: 2,
  },
];

export const MONITORING_QUEUE_DETAILS_FOR_TYPES = {
  CLIENT: 0,
  WATCHLIST_MATCHES_LIST: 1,
  INPUT_PARAMS: 2,
};

export const CLIENT_TYPE_OPTIONS = [
  { value: "Person", label: "Natural person" },
  { value: "Company", label: "Legal entity" },
];

export const CLIENT_TYPE_VALUES = {
  PERSON: "Person",
  COMPANY: "Company",
};

export const CLIENT_TYPE_LABELS = {
  Person: "Natural person",
  Company: "Legal entity",
};

export const INITIAL_FILTERS = {
  type: null,
  riskLevel: null,
  status: null,
  hasWatchListMatch: null,
  dateFrom: null,
  dateTo: null,
  clientType: null,
  NegativeMediaDecision: null,
  HasNegativeMediaElasticBasedMatch: null,
  HasNegativeMediaMatch: null,
  scoringStatus: null,
  RiskCriteriaName: null,
  RiskCriteriaValue: null,
  clientName: "",
  clientNumber: "",
  clientOfferId: "",
  customClientParameters: [],
  IsClientActive: null,
  WatchListSearchingDecisionTypeFilter: null,
  RegularSearchingCategoryType: null,
};

export const FILTERS_LABELS = {
  type: "Type of check:",
  riskLevel: "Risk level:",
  status: "Scoring status:",
  hasWatchListMatch: "Presence in Watchlists:",
  dateFrom: "Date from:",
  dateTo: "Date to:",
  clientType: "Client type:",
  clientName: "Client name:",
  clientNumber: "Client EGN / Company Number:",
  clientOfferId: "Offer ID:",
  NegativeMediaDecision: "Decision:",
  HasNegativeMediaMatch: "Negative Media:",
  scoringStatus: "Scoring status:",
  RiskCriteriaName: "Risk Criteria Name:",
  RiskCriteriaValue: "Risk Criteria Value:",
  IsClientActive: "Active:",
  HasNegativeMediaElasticBasedMatch: "Negative Media:",
  WatchListSearchingDecisionTypeFilter: "Watchlist Decision:",
  RegularSearchingCategoryType: "Watchlist Types",
};

export const TABLE_HEADER_DROPDOWN_VALUES = {
  ON_THIS_PAGE: "All on this page",
  ALL: "All",
  NONE: "None",
  scoringStatus: "Scoring status:",
  RiskCriteriaName: "Risk Criteria Name:",
  IsClientActive: "Active:",
};

export const PRESENCE_IN_WATCHLISTS_OPTIONS = [
  {
    label: "Yes",
    value: true,
  },
  {
    label: "No",
    value: false,
  },
];



// WEBPACK FOOTER //
// ./src/features/monitoring-queue-entry/constants/monitoringQueueEntryConstants.js